import * as fromRoot from '../../state/app.reducer';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ParameterActions, ParameterActitonTypes } from './parameter.actions';
import { Parameter } from '../../_models/parameter';

export interface State extends fromRoot.State {
	parameters: ParameterState;
}

export interface ParameterState {
  currentParameter: Parameter;
	parameterList: Parameter[];
	error: string;
}

const initialItem: Parameter = {
  id: null,
  setup_prog: '',
  setup_user: '',
  setup_key: '',
  setup_type: '',
  setup_value: null,
  setup_unit: '',
  setup_group: null,
  setup_permission: '',
  setup_value2: null,
  setup_value3: null,
  setup_value4: null,
  setup_value5: null,
  setup_value6: '',
  actived: false
};

const initialState: ParameterState = {
  currentParameter: initialItem,
	parameterList: [],
	error: ''
};

const getParameterFeatureState = createFeatureSelector<ParameterState>('parameters');

export const getParameterList = createSelector(
	getParameterFeatureState,
	state => state.parameterList
);

export const getError = createSelector(
	getParameterFeatureState,
	state => state.error
);

// Primer parámetro es el "estado ngrx" almacenado en ese momento.
// Segundo parámetro es la acción que se va a procesar.
export function reducer(state = initialState, action: ParameterActions): ParameterState {

	// console.log('--> Parameter Reduce --> Estado actual: ' + JSON.stringify(state));
	// console.log('--> Action Parameter type: ');
	// console.log(action.type);

	switch (action.type) {

		case ParameterActitonTypes.SetCurrentParameter:

			console.log('--> Entando en acción SetCurrentParameter.');

			if (action.payload !== null) {

				return {
					...state,
					// currentParameterId: action.payload.setup_prog,
					currentParameter: action.payload
				};
			} else {
				return {
					...state,
				// currentParameterId: null,
					currentParameter: initialItem
				};
			}

    case ParameterActitonTypes.GetCurrentParameter:

			console.log('--> Entando en acción GetCurrentParameter.');

			return state;


		case ParameterActitonTypes.InicializeParameter:

			console.log('--> Entando en acción InicializeParameter.');

			state = initialState;

			return state;


		case ParameterActitonTypes.LoadParametersSuccess:

			console.log('--> Entrando en acción LoadParametersSuccess. => Payload = ');
			// console.log(action.payload);

			return {
					...state,
					parameterList: action.payload,
					error: ''
				};

		case ParameterActitonTypes.LoadParametersFail:

			console.log('--> Entando en acción LoadParametersFail. => Payload = ');
			console.log(action.payload);

			return {
					...state,
					parameterList: [],
					error: action.payload
				};

		case ParameterActitonTypes.UpdateParameterSuccess:

			console.log('--> Entando en acción UpdateParameterSuccess.');

			// Se actualiza en los proyectos actuales el proyecto que se ha modificado y el resto se deja como estaba.

			let auxParameterList = [];

			if (action.payload !== undefined) {
				console.log(' -> El parámetro a modificar es:');
				console.log(action.payload);

				if (action.payload != null) {
					auxParameterList = state.parameterList.map(
					item => action.payload.setup_prog === item.setup_prog ? action.payload : item);

					return {
						...state,
						parameterList: auxParameterList,
						error: ''
					};
				}

				return state;

			} else {
				console.log(' -> El parámetro a modificar está vacía.');

				return {
					...state,
					error: 'No se ha podido modificar el parámetro.'
				};
			}

		case ParameterActitonTypes.UpdateParameterFail:

			console.log('--> Entrando en acción UpdateParameterFail.');

			return {
					...state,
					error: action.payload
				};

		default:
			return state;
	}
}
